import InlineMessage from '@ingka/inline-message';
import { IntlShape, useIntl } from 'react-intl';
import { useDispatch } from 'react-redux';
import { Dispatch } from 'react';
import { ErrorMessage } from '../utils/errorMessages';
import InformationIcon from '@ingka/ssr-icon/paths/information-circle';
import { useCore } from 'contexts/core';
import { CoreApi } from '@inter-ikea-storageone/range';
import { useTranslations } from 'hooks/useTranslations';
import { IStorageOneTranslations, useServiceSettings } from 'contexts/serviceSettings';

export interface ErrorMessageInlineProps {
  getMessage: (
    dispatch: Dispatch<any>,
    coreApi: CoreApi,
    useMetric: boolean,
    formatMessage: IntlShape['formatMessage'],
    translations: IStorageOneTranslations
  ) => ErrorMessage;
}

const ErrorMessageInline = ({ getMessage }: ErrorMessageInlineProps) => {
  const { formatMessage } = useIntl();
  const dispatch = useDispatch();
  const coreApi = useCore();
  const { useMetric } = useTranslations();
  const { translations } = useServiceSettings();
  const { title, body, params, type, action, ssrIcon } = getMessage(
    dispatch,
    coreApi,
    useMetric,
    formatMessage,
    translations
  );

  const actions = action ? [{ ...action, text: formatMessage({ id: action.text }) }] : [];

  return (
    <InlineMessage
      title={title?.startsWith('storageone.') ? formatMessage({ id: title }) : title}
      body={formatMessage({ id: body }, params)}
      variant={type ?? 'negative'}
      actions={actions}
      ssrIcon={ssrIcon ? ssrIcon : type === 'informative' ? InformationIcon : undefined}
    />
  );
};

export default ErrorMessageInline;
